import { get } from './shared';

export const getBankList = get(`/:paymentId/experience/initialization/instantBankTransfer`);

export const getTransferRedirectDetails = get(
  `/:paymentId/experience/result/instantBankTransfer?issuerId=:issuerId&frontendAttemptId=:frontendAttemptId`,
);
